<template>
<div>
    <div class="app-title">
        <div>
                <h2>{{ $t("tlt.role.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/adm/role/edit"><span>{{$t('tlt.role.add')}}</span></router-link></li>
                </ul>
            </div>
        <div class="col-lg-4">
            <div class="float-lg-right">
                <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('role')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>{{$t('btn.basic.cancel')}}</span></button>
                <button class="btn btn-primary" type="button" v-on:click="MMFSave('role')"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
            </div>
        </div>
    </div>
    <section class="app-content">
        <form>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.name')}}:</label>
                            <input v-validate="'required'" name="roleName" :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('roleName') }" v-model="roleName" type="text" v-bind:disabled="id!=null">
                            <span v-show="errors.has('roleName')" class="lbl-obg">
                                {{ errors.first('roleName') }}
                            </span>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.basic.description')}}:</label>
                            <input :class="{'form-control form-control-sm': true}" v-model="description" type="text">                            
                        </div>                        
                    </div>
                </div>
            </div>
        </form>
        <div class="card" style="margin-top:20px">
            <div class="card-body">
                <div class="row" :key="index" v-for="(item,index) in resources">
                    <div class="col-md-3">
                        <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.role.resources.resourceType')}}:</label>
                        <select v-validate="'required'"  name="resourceType" 
                        :class="{'form-control': true, 'is-invalid': errors.has('resourceType') }" 
                        v-model="item.resourceType" >
                                <option value="equipment-设备">{{ $t("tlt.equipment") }}</option>

                                <!-- <option value="administration-系统管理">{{ $t("tlt.administration") }}</option> -->
                                <option value="systemParameters-系统参数">{{ $t("tlt.systemParameters") }}</option>
                                <option value="reportTemplateList-报表模板">{{ $t("tlt.reportTemplateList") }}</option>
                                <option value="role-角色管理">{{ $t("tlt.role") }}</option>
                                <option value="user-用户管理">{{ $t("tlt.user") }}</option>
                                <option value="dataField-阈值管理">{{ $t("tlt.thresholdSettings") }}</option>
                                <option value="quartzSchedule-定时任务">{{ $t("tlt.scheduleJob") }}</option>
                                <option value="operationLog-操作日志">{{ $t("tlt.log") }}</option>

                                <option value="location-工厂模型">{{ $t("tlt.location") }}</option>
                                <option value="material-物料主数据">{{ $t("tlt.material") }}</option>
                                <option value="energy-能源主数据">{{ $t("tlt.energy") }}</option>
                                <option value="teamShift-排班管理">{{ $t("tlt.teamShift") }}</option>
                                <option value="processConf-工艺配置">{{ $t("tlt.processConf") }}</option>

                                <option value="monthPlan-月生产计划">{{ $t("tlt.monthPlan") }}</option>
                                <option value="shiftPlan-班次生产计划">{{ $t("tlt.shiftPlan") }}</option>
                                <option value="matRequireMonthPlan-大宗物料需求月计划">{{ $t("tlt.matRequireMonthPlan") }}</option>
                                <option value="downtimePlan-停机计划">{{ $t("tlt.downtimePlan") }}</option>
                                <option value="formulaPlan-配料计划">{{ $t("tlt.formulaPlan") }}</option>
                                <option value="productionInform-生产经营通告">{{ $t("tlt.productionInform") }}</option>

                                <option value="pelletizingPrdResult-球团生产实绩">{{ $t("tlt.pelletizingPrdResult") }}</option>
                                <option value="pelletizingOperationRecord-球团调度记录">{{ $t("tlt.pelletizingOperationRecord") }}</option>
                               
                                <option value="smeltingPrdResult-冶炼生产实绩">{{ $t("tlt.smeltingPrdResult") }}</option>
                                <option value="smeltingMaterialPercentRecord-冶炼配料记录">{{ $t("tlt.smeltingMaterialPercentRecord") }}</option>
                                <option value="smeltingPreheatingKilnManagement-预热窑运行管理">{{ $t("tlt.smeltingPreheatingKilnManagement") }}</option>
                                <option value="furnaceMeasure-炉体测量">{{ $t("tlt.furnaceMeasure") }}</option>
                                <option value="electrodeOperationManagement-电极运行管理">{{ $t("tlt.electrodeOperationManagement") }}</option>
                                <option value="gasCabinetPara-煤气柜运行管理">{{ $t("tlt.gasCabinetPara") }}</option>
                                <option value="slagIronPara-出渣出铁管理">{{ $t("tlt.slagIronPara") }}</option>
                                <option value="substationOperationPara-冶炼炉变运行参数">{{ $t("tlt.substationOperationPara") }}</option>

                                <option value="pelletizingSeltTest-球团自检管理">{{ $t("tlt.selfTestPelletizing") }}</option>
                                <option value="sampleInfo-样品登记/报检">{{ $t("tlt.sampleInfo") }}</option>  
                                <option value="sampleReceive-样品接收">{{ $t("tlt.sampleReceive") }}</option>
                                <option value="sampleCheck-样品检验">{{ $t("tlt.sampleCheck") }}</option>
                                <option value="qualityResult-检验结果查询">{{ $t("tlt.qualityResult") }}</option>
                                <option value="qualityReview-质量复检">{{ $t("tlt.qualityReview") }}</option>
                                <option value="slagMeltingPoint-渣熔点系数">{{ $t("tlt.slagMeltingPoint") }}</option>


                                <option value="shiftHandOver-班组交接">{{ $t("tlt.shiftHandOver") }}</option>
                                <option value="inventory-库存管理">{{ $t("tlt.inventory") }}</option>
                                <option value="qualityConf-检验配置">{{ $t("tlt.qualityConf") }}</option>
                                                              
                                <option value="pelletizingReport-球团报表">{{ $t("tlt.pelletizingReport") }}</option>
                                <option value="smeltingReport-冶炼报表">{{ $t("tlt.smeltingReport") }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="control-label"><span class="lbl-obg">*</span>功能</label>
                        <b-form-select v-model="item.functions" :class="{'form-control': true, 'is-invalid': errors.has('functions') }"  
                            :options="functionArr[index]" multiple :select-size="3">
                        </b-form-select>
                    </div>
                    <div class="col-md-3">
                        <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.role.resources.scopes')}}:</label>
                        <b-form-select v-model="item.scopes" :class="{'form-control': true, 'is-invalid': errors.has('scope') }"  
                            :options="options" multiple :select-size="3"></b-form-select>
                    </div>
                                 
                    <div class="col-md-1">
                        <label class="control-label"><span class="lbl-obg" style="color:white">1</span></label>
                        <div>
                           <b-button v-if="resources.length!=1" class="btn btn-danger" @click="deleteOne(index)">删除</b-button>
                            <b-button v-if="(index+1)==resources.length" class="btn btn-warning" @click="addNew()">添加</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>
</template>

<script>
import {
    mapFields,
    mapMultiRowFields
} from 'vuex-map-fields';
import {
    mapActions,
    mapState
} from "vuex";

export default {
    name: 'roleEdit',

    data() {
        return {
            options:[]
        }
    },
    components: {},
    computed: {
        ...mapFields('role',['entity.roleName','entity.description','entity.id']),
        ...mapMultiRowFields('role',['entity.resources']),
        ...mapState({
            allMenus: state => state.role.allMenus,
        }),
        functionArr: function() {
            var arr = new Array();
            for(var i = 0; i < this.resources.length; i++) {
                var moduleStr = this.resources[i].resourceType;
                arr[i] = this.searchFunctions(moduleStr);
            }

            return arr;
        }
    },
    methods: {
        ...mapActions("base", ["MMFbackToList", "MMFSave"]),
        addNew() {
            var ob = {
                resourceType: '',
                functions: [''],
                scopes: ['']
            }
            const context = this.$store;
            context.commit("role/addResource",ob);
        },
        deleteOne(index) {
            const context = this.$store;
            context.commit("role/deleteResource",index);
        },
        createFuncionsArr() {
            const context = this.$store;
            var arr = new Array();
            for(var i = 0; i < this.resources.length; i++) {
                var moduleStr = this.resources[i].resourceType;
                arr[i] = this.searchFunctions(moduleStr);
            }
            this.functionArr = arr;

            context.commit("role/updateResources");
        },
        searchFunctions(moduleStr) {
            var arr = new Array();
            var menuArr = this.allMenus;
            for(var i = 0, len = menuArr.length; i < len; i++) {
                var menu = menuArr[i];
                if(moduleStr == menu.moduleName) {
                    var ob = {};
                    ob.value = String(menu.copId);
                    ob.text = menu.fullName;
                    arr.push(ob);
                }
            }
            return arr;
        },
        updateFunctionArr(event,index) {
            var moduleStr = event.target.value;
            this.functionArr[index] = this.searchFunctions(moduleStr);
        },
        convertResourceFunctionAndScope() {
            const context = this.$store;
            context.commit("role/updateResources");
        }
    },
    created() {
        this.options = this.$store.state.role.options;
        this.convertResourceFunctionAndScope();
    },
};
</script>
